/**
 * Shared definitions for the Local Inventory Ads insight tables (Popular
 * products, Local search terms, Clicks to in-store sales).
 *
 * The Results and Ads pages render the top few rows of each as a summary card
 * with a "View more" button; the dedicated `/ads/insights/:metric` page renders
 * the same table in full. Keeping the title / sub / columns in one place stops
 * the summary card and its detail page from drifting apart.
 */
const numberFormatter = new Intl.NumberFormat('en-GB');
export const formatInsightNumber = (n) => numberFormatter.format(Number(n) || 0);

// Number of rows each summary card shows before the "View more" button. The
// detail page shows the full range (capped server-side in local-ads.js).
export const SUMMARY_ROWS = 6;

export const LIA_INSIGHT_METRICS = {
	products: {
		dataKey: 'topProducts',
		title: 'Popular products',
		sub: 'What locals are clicking on most from your ads.',
		emptyLabel: 'No clicks yet — give it a couple of days.',
		columns: [
			{ key: 'name', label: 'Product' },
			{ key: 'impressions', label: 'Views', width: '5rem', render: (r) => formatInsightNumber(r.impressions) },
			{ key: 'clicks', label: 'Clicks', width: '4rem', render: (r) => formatInsightNumber(r.clicks) }
		]
	},
	'search-terms': {
		dataKey: 'searchTerms',
		title: 'Local search terms',
		sub: 'What people typed into Google to find your store.',
		emptyLabel: 'No search-term data yet.',
		columns: [
			{
				key: 'term',
				label: 'Search term',
				render: (r) => <span className="text-sm font-medium">&ldquo;{r.term}&rdquo;</span>
			},
			{ key: 'impressions', label: 'Views', width: '5rem', render: (r) => formatInsightNumber(r.impressions) },
			{ key: 'clicks', label: 'Clicks', width: '4rem', render: (r) => formatInsightNumber(r.clicks) }
		]
	},
	'clicks-to-sales': {
		dataKey: 'clicksToSales',
		title: 'Clicks to in-store sales',
		sub: 'Products that were clicked from your ads and then bought in store within 24 hours.',
		emptyLabel: 'No in-store sales attributed yet.',
		columns: [
			{ key: 'product', label: 'Product' },
			{ key: 'clicks', label: 'Clicks', width: '4rem', render: (r) => formatInsightNumber(r.clicks) },
			{ key: 'sales', label: 'Suspected sales', width: '7rem', render: (r) => formatInsightNumber(r.sales) }
		]
	}
};
